import { environment } from "src/environments/environment";

function createUrl(actionName: string): string {
  return `${environment.apiBaseUrl}${environment.apiUrl}${environment.apiVersion}${actionName}`;
}

export const SearchApiResources = {
  search:  createUrl('purchase/orders/joblisting'),
  scopeSearch:  createUrl('purchase/orders/jobscopes'),
  vendorSearch:  createUrl('purchase/orders/vendors-by-product'),
  generalVendorSearch:  createUrl('vendors/search'),
  vendorQuoteSearch:  createUrl('vendor-quotes/search'),
  vendorQuoteByVendor: (vendorId: string) => createUrl(`vendor_quote/${vendorId}/listing`),
  createInvitation: (poId: string) => createUrl(`purchase/orders/${poId}/invitations`),
  getInvitation: (poId: string) => createUrl(`purchase/orders/${poId}/invitations`),
  updateInvitation: (poId: string, invitationId: string) => createUrl(`purchase/orders/${poId}/invitations/${invitationId}`),
  updateStatus: (poId: string) => createUrl(`purchase/orders/${poId}/status`),
  getOpenPOsByVendor: createUrl('purchase/orders/open'),
  createConsolidationRequest: (poId: string) => createUrl(`purchase/orders/${poId}/consolidation-requests`),
  getConsolidationRequests: (poId: string) => createUrl(`purchase/orders/${poId}/consolidation-requests`),
  getConsolidationRequestsByJob: (jobId: string) => createUrl(`jobs/${jobId}/consolidation-requests`),
  approveConsolidationRequest: (requestId: string) => createUrl(`consolidation-requests/${requestId}/approve`),
  rejectConsolidationRequest: (requestId: string) => createUrl(`consolidation-requests/${requestId}/reject`),
  removeConsolidationRequest: (requestId: string) => createUrl(`consolidation-requests/${requestId}`),
  mergeApprovedRequests: (poId: string) => createUrl(`purchase/orders/${poId}/merge-approved-requests`),
  deleteConsolidationRequestsByVendor: (jobId: string, vendorId: string) => createUrl(`jobs/${jobId}/consolidation-requests/vendor/${vendorId}`),
};
